import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_COMM_1M_29_99_6M_9_EN_CLUSTER',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_comm_1m_29_99_6m_9_usd',
			GBP: 'simple_premium_comm_1m_29_99_6m_10_gbp',
			CAD: 'simple_premium_comm_1m_49_99_6m_13_cad',
			AUD: 'simple_premium_comm_1m_49_99_6m_16_aud',
		},
		primer: 'prd_ivZn4KpUAolv',
	},
	model: {
		commitment_period: 6,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 9,
			GBP: 10,
			CAD: 13,
			AUD: 16,
		},
		originalPriceMap: {
			USD: 29.99,
			GBP: 29.99,
			CAD: 49.99,
			AUD: 49.99,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 29.99,
			GBP: 29.99,
			CAD: 49.99,
			AUD: 49.99,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		footerPeriodText: $t('pages.special_upsale.upgrade_durations.6'), // 6-month
		footerIntervalText: $t('pages.program.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
	}),
}
